/*
    This is the Wallspice app.
    Where all the other components
    come together.
*/

import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { bool } from 'prop-types'

import * as pageOptions from 'constants/pageOptions'

import { getHasOutage } from 'models/support/selectors'
import ErrorMessage from 'components/ErrorMessage'

import DesignPage from 'pages/DesignPage'
import ProfilePage from 'pages/ProfilePage'
import DashboardPage from 'pages/DashboardPage'
import LearnMorePage from 'pages/LearnMorePage'
import PrivacyPolicyPage from 'pages/PrivacyPolicyPage'
import AccountAccessPage from 'pages/AccountAccessPage'
import SharedPage from 'pages/SharedPage'

import HeaderContainer from 'containers/HeaderContainer'
import FooterContainer from 'containers/FooterContainer'

import ToastDisplay from 'toasts/ToastDisplay'

const Sugarcube = ({ hasOutage }) =>
    hasOutage ? (
        <ErrorMessage />
    ) : (
        <>
            <ToastDisplay />
            <Route path="/" component={HeaderContainer} />
            <Switch>
                <Route path="/" exact component={LearnMorePage} ignoreScrollBehavior />
                <Route path="/dashboard" exact component={DashboardPage} />
                <Route path="/about" exact component={LearnMorePage} />
                <Route path="/profile" component={ProfilePage} />
                <Route path="/design" component={DesignPage} />
                <Route path="/signup" render={() => <AccountAccessPage page={pageOptions.SIGNUP} />} />
                <Route path="/login" render={() => <AccountAccessPage page={pageOptions.LOGIN} />} />
                <Route path="/recover" render={() => <AccountAccessPage page={pageOptions.RECOVER} />} />
                <Route path="/reset" render={() => <AccountAccessPage page={pageOptions.RESET} />} />
                <Route path="/privacypolicy" render={() => <PrivacyPolicyPage page={pageOptions.PRIVACY} />} />
                <Route path="/termsofuse" render={() => <PrivacyPolicyPage page={pageOptions.TERMS} />} />
                <Route path="/shared/:compositionUuid" exact component={SharedPage} />
                <Route component={LearnMorePage} />
            </Switch>
            <Route path="/" component={FooterContainer} />
        </>
    )

Sugarcube.propTypes = {
    hasOutage: bool.isRequired,
}

const mapStateToProps = (state) => ({
    hasOutage: getHasOutage(state),
})

export default connect(mapStateToProps)(Sugarcube)
